import { render, staticRenderFns } from "./OtherReceiptList.vue?vue&type=template&id=553df1c2&scoped=true&"
import script from "./OtherReceiptList.vue?vue&type=script&lang=js&"
export * from "./OtherReceiptList.vue?vue&type=script&lang=js&"
import style0 from "./OtherReceiptList.vue?vue&type=style&index=0&id=553df1c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553df1c2",
  null
  
)

export default component.exports